import React from 'react';
import PropertytypeTownhouseOutlineIcon from './propertytype_townhouse_outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TownhouseIcon(props) {
  return ___EmotionJSX(PropertytypeTownhouseOutlineIcon, props);
}